<template>
  <div>
    <input ref="inputField" type="time" class="form-control" :value="value" @input="inputUpdated" />
    <div class="form-invalid-feedback" v-if="hasError()">
      {{getError()}}
    </div>
    <div v-if="!hasError() && note" class="form-field-note">{{note}}</div>
  </div>
</template>

<script>
import formField from '@/mixins/formField'
export default {
  name: 'FormTime',
  mixins: [formField],
  model: {
    event: 'input'
  },
  props: {
    value: String,
    field: String,
    note: String
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
    focus() {
      this.$refs.inputField.focus()
    },
    select() {
      this.$refs.inputField.select()
    },
    inputUpdated(evt) {
      this.$emit('input', evt.target.value)
    },
  }
}
</script>